import React from 'react';
import styled from 'styled-components';
import {AboutUs, BannerApp, Carousel, Departments, SectionSocial} from '../../components/public';
import {departments} from '../../data-list';
import {CencosudCupon} from "../../components/public/home/CencosudCupon";

export const Home = () => (
	<Container>
		<Carousel />
		<AboutUs />
        <CencosudCupon />
		<BannerApp />
		<Departments departments={departments} />
		{/*<Contact />*/}
		<SectionSocial />
	</Container>
);

const Container = styled.div`
	width: 100%;
	height: auto;
`;
